import { SStyled } from '../../../styles/theme'

export const ResponsiveText = SStyled.p`
    margin-top: 24px;
    margin-bottom: 0px;
    white-space: pre-line;
    text-align: left;
    font-size: 14px;
    line-height: 140%;
    font-weight: 400;
    
    ${(p) => `
        @media screen and (max-width: ${p.theme.breakpoints[0]}) {
            font-size: 14px;
        }
    `}
`

export const ResponsiveHeaderText = SStyled.h1`
    font-size: 32px;
    text-align: left;
    line-height: 120%;
    font-weight: 900;
    margin-top: 24px;
    margin-bottom: 0px;
    
    ${(p) => `
        @media screen and (max-width: ${p.theme.breakpoints[0]}) {
            font-size: 24px;
            line-height: 130%;
        }
    `}
`

export const ResponsiveSubHeaderText = SStyled.h2`
    margin-top: 24px;
    'white-space': 'pre-line',
    'text-Align': 'left',
    'font-size': '14px',
    'line-height': '140%',
    'font-weight': '700',

    ${(p) => `
        @media screen and (max-width: ${p.theme.breakpoints[0]}) {
            font-size: 14px;
            line-height: 130%;
            color: #202020;
            opacity: 87%;
        }
    `}
`
